export const UPDATE_CONVERSATIONS = "UPDATE_CONVERSATIONS";
export const CREATE_CONVERSATION = "CREATE_CONVERSATION";
export const UPDATE_MESSAGES_BY_ID = "UPDATE_MESSAGES_BY_ID";
export const DELETE_CONVERSATION = "DELETE_CONVERSATION";
export const SELECTED_CONVERSATION = "SELECTED_CONVERSATION";
export const UPDATE_PARTICIPANTS = "UPDATE_PARTICIPANTS";
export const DELETE_MESSAGES_BY_ID = "DELETE_MESSAGES_BY_ID";
export const DELETE_PARTICIPANTS = "DELETE_PARTICIPANTS";
export const UPDATE_UNREAD_MSG_COUNT = "UPDATE_UNREAD_MSG_COUNT";
export const DELETE_UNREAD_MSG_COUNT = "DELETE_UNREAD_MSG_COUNT";
export const DELETE_ALL_MESSAGES = "DELETE_ALL_MESSAGES";
export const UPDATE_INITIAL_STATE = "UPDATE_INITIAL_STATE";
export const UPDATE_PAGE = "UPDATE_PAGE";
export const UPDATE_CUSTOMERDETAILS = "UPDATE_CUSTOMERDETAILS";